var _style, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconCalidad(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 88.13 88.13",
    style: {
      enableBackground: "new 0 0 88.13 88.13"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#FF0000;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_7_",
    className: "st0",
    d: "M44.06,0.56c-23.99,0-43.5,19.51-43.5,43.5c0,23.98,19.51,43.5,43.5,43.5s43.5-19.52,43.5-43.5 S68.05,0.56,44.06,0.56z M44.06,80.39c-20.03,0-36.33-16.3-36.33-36.33S24.03,7.73,44.06,7.73s36.33,16.3,36.33,36.33 C80.39,64.1,64.1,80.39,44.06,80.39z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 21.44,
    y: 37.65,
    className: "st0",
    width: 11.47,
    height: 26.76
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M65.51,40.47c-1.58-1.58-3.17-3.17-4.75-4.75h-9.13l2.18-5.53l0.62-1.57l-0.06-0.45l-1.34-10.69l-6.58-0.51 l-2.42,8.33L37.6,35.73v28.68h23.77L65.51,40.47z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M65.51,40.47"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCalidad);
export default __webpack_public_path__ + "static/media/icon-calidad.5118c01b77cdccda460da0701fc17916.svg";
export { ForwardRef as ReactComponent };